module.exports = __webpack_public_path__ + "img/kagami.cc7623ae.png";